<template>
  <div class="orders">
    <!-- <h2>Dem Orders</h2> -->
    <linear-loader
      v-if="retrieveOrdersStatus === 1"
      text="Fetching your orders"
    />
    <div v-else>
      <!-- {{ orders }} -->
      <template v-if="orders.length > 0">
      <div
        v-for="(order, i) in orders"
        :key="`order-${i}`"
        class="pointer"
        @click.prevent="gotoOrder(order.id)"
      >
        <order-display class="order-container" :order="order" />
      </div>
      </template>
      <div class="text-center" v-else>
        <h2>No Orders</h2>
        <p>
          You haven't made any orders yet.
        </p>
        <p>
          <router-link class="btn" :to="{ name: 'Home' }">Shop Now</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import LinearLoader from "@/components/loaders/LinearLoader.vue";
import OrderDisplay from "./components/OrderDisplay.vue";

export default {
  name: "Orders",
  components: {
    LinearLoader,
    OrderDisplay,
  },
  computed: {
    ...mapGetters({
      orders: "Orders/orders",
      retrieveOrdersStatus: "Orders/getOrdersStatus",
    }),
  },
  created() {
    this.$store.dispatch("Orders/getOrders");
  },
  methods: {
    gotoOrder(orderId) {
      this.$router.push({ name: "OrderDetails", params: { id: orderId } });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-container {
  background-color: white;
  padding: 0.75rem;
}
</style>
<style lang="scss">
.theme-dark {
  .order-container {
    background-color: #212121 !important;
  }
}
</style>